<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Margin Top</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="top-slider"
            v-model="top"
            :interval="1"
            adsorb
            tooltip="none"
            :duration="0"
            :data="topMarginClasses"
        ></vue-slider>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Margin Bottom</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="bottom-slider"
            v-model="bottom"
            :interval="1"
            adsorb
            tooltip="none"
            :duration="0"
            :data="bottomMarginClasses"
        ></vue-slider>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Margin Left</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="bottom-slider"
            v-model="left"
            :interval="1"
            adsorb
            tooltip="none"
            :duration="0"
            :data="leftMarginClasses"
        ></vue-slider>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Margin Right</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="bottom-slider"
            v-model="right"
            :interval="1"
            adsorb
            tooltip="none"
            :duration="0"
            :data="rightMarginClasses"
        ></vue-slider>
      </div>
    </li>
  </div>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { MarginTopClasses, MarginBottomClasses, MarginLeftClasses, MarginRightClasses } from '../classes/MarginClasses'
  export default MenuStyleProperty.extend({
    computed: {
      topMarginClasses() {
        return Object.keys(MarginTopClasses)
      },
      bottomMarginClasses() {
        return Object.keys(MarginBottomClasses)
      },
      leftMarginClasses() {
        return Object.keys(MarginLeftClasses)
      },
      rightMarginClasses() {
        return Object.keys(MarginRightClasses)
      },
      top: {
        get() {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.topMarginClasses.includes(elementClass.value))
          if (! currentMargin) {
            currentMargin = {property: 'MarginTop', value: 'MARGIN_TOP_NONE', touched: false}
            this.addToArray(this.module, [currentMargin], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentMargin.value
        },

        set: _.debounce(function (value) {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.topMarginClasses.includes(elementClass.value))
          value = {property: 'MarginTop', value: value, touched: currentMargin.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      bottom: {
        get() {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.bottomMarginClasses.includes(elementClass.value))
          if (! currentMargin) {
            currentMargin = {property: 'MarginBottom', value: 'MARGIN_BOTTOM_NONE', touched: false}
            this.addToArray(this.module, [currentMargin], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentMargin.value
        },

        set: _.debounce(function (value) {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.bottomMarginClasses.includes(elementClass.value))
          value = {property: 'MarginBottom', value: value, touched: currentMargin.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      left: {
        get() {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.leftMarginClasses.includes(elementClass.value))
          if (! currentMargin) {
            currentMargin = {property: 'MarginLeft', value: 'MARGIN_LEFT_NONE', touched: false}
            this.addToArray(this.module, [currentMargin], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentMargin.value
        },

        set: _.debounce(function (value) {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.leftMarginClasses.includes(elementClass.value))
          value = {property: 'MarginLeft', value: value, touched: currentMargin.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      right: {
        get() {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.rightMarginClasses.includes(elementClass.value))
          if (! currentMargin) {
            currentMargin = {property: 'MarginRight', value: 'MARGIN_RIGHT_NONE', touched: false}
            this.addToArray(this.module, [currentMargin], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentMargin.value
        },

        set: _.debounce(function (value) {
          let currentMargin = this.elementClasses(this.classes)[this.device].find(elementClass => this.rightMarginClasses.includes(elementClass.value))
          value = {property: 'MarginRight', value: value, touched: currentMargin.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    },
  })
</script>